class Contacts {
	constructor(el) {
		if (!el) return
		this.dom = {}
		this.dom.el = el
		this.setupDom()
		this.bindEvents()
	}

	setupDom = () => {
		this.dom.allAreasTag = document.getElementById('allAreasTag')
		this.dom.areaTags = Array.from(this.dom.el.querySelectorAll('.area-buttons input.tag'))
		this.dom.areas = Array.from(this.dom.el.querySelectorAll('.office-area > li'))
		this.dom.allCategoriesTag = document.getElementById('allCategoriesTag')
		this.dom.categoryTags = Array.from(this.dom.el.querySelectorAll('.category-buttons input.tag'))
		this.dom.categories = Array.from(this.dom.el.querySelectorAll('.office-area > li'))
		this.dom.contacts = Array.from(this.dom.el.querySelectorAll('.area-contacts > li:not(#contacts-no-hits)'))
		this.dom.nohits = document.getElementById('contacts-no-hits')
		this.dom.search = document.getElementById('search-contacts-input')
	}

	bindEvents = () => {
		this.dom.areaTags?.forEach(tag => tag.addEventListener('change', this.doFilter))
		this.dom.allAreasTag?.addEventListener('change', this.doFilter)
		this.dom.categoryTags?.forEach(tag => tag.addEventListener('change', this.doFilter))
		this.dom.allCategoriesTag?.addEventListener('change', this.doFilter)
		this.dom.search?.addEventListener('keyup', this.doSearch)
		this.dom.search?.addEventListener('input', this.doSearch)
	}

	doFilter = () => {
		if (this.dom.allAreasTag.checked) {
			this.dom.areas.forEach(a => {
				if (a.classList.contains("main-office")) {
					a.classList.remove("hidden")
				}
				else {
					a.classList.add("hidden")
				}
			})
			this.dom.contacts.forEach(c => {
				c.classList.remove("hidden")
			})
		}
		else {
			var selected = this.dom.areaTags.find(tag => tag.checked)?.dataset.area
			this.dom.areas.forEach(a => {
				a.dataset.area !== selected ? a.classList.add("hidden") : a.classList.remove("hidden")
			})
			this.dom.contacts.forEach(c => {
				c.dataset.areas?.split(',').includes(selected) ? c.classList.remove("hidden") : c.classList.add("hidden")
			})
		}
		var visible = this.dom.contacts.filter(c => c.classList.contains("hidden") === false)
		if (this.dom.allCategoriesTag?.checked === false) {
			var selected = this.dom.categoryTags.find(tag => tag.checked)?.dataset.category
			visible.forEach(c => {
				if (c.dataset.categories?.split(',').includes(selected) === false) {
					c.classList.add("hidden")
				}
			})
			visible = this.dom.contacts.filter(c => c.classList.contains("hidden") === false)
		}
		if (!this.query) {
			this.dom.contacts.forEach(c => c.classList.remove("nomatch"))
		}
		else {
			this.dom.contacts.forEach(c => c.dataset.name.includes(this.query) ? c.classList.remove("nomatch") : c.classList.add("nomatch"))
		}
		!visible.length ? this.dom.nohits.classList.remove("hidden") : this.dom.nohits.classList.add("hidden")
	}

	doSearch = e => {
		this.query = e.currentTarget?.value?.toLowerCase() || ""
		this.doFilter()
	}

	static init = () => {
		const contactPage = document.querySelector('.c-contacts')
		new Contacts(contactPage)
	}
}

export default Contacts
